import React from "react";
import { BaseChat } from "./chat/BaseChat";
import { useLocation } from "react-router-dom";

export const Chat: React.FC = () => {
  const location = useLocation();
  const searchParams = new URLSearchParams(location.search);
  const dmid = searchParams.get("dmid");

  return (
    <BaseChat
      endpoint="/ws/chat/"
      queryParams={dmid ? { dmid } : undefined}
    />
  );
};
